export const CodeTypeName = {
    DeviceType: 'DeviceType',
    OperationType : 'OperationType'
};

